import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import FlagAppend from "./flagAppend";
import Recovered from "./recovered";
import AnnouncementBulk from "pages/announcement/announcementBulk";

const API = localStorage.getItem("assethost");

export default class MyFlaggedItemsLaw extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      msg: "",
      toastColor: "",
      flaggedAssets: [],
      category: "",
      uniqueIdentifier: "",
      assetStatus: "",
      page: 0,
      size: 10,
      totalPages: 1,
      errors: {},
      categories: [],
      statuses: [],
      checkedList: [],
      checkedAll: false,
      currentAssetId: "",
      currentAssetType: "",
      currentAssetBrand: "",
      currentAssetModel: "",
      currentAssetUniqueIdentier: "",
      flag: null,

      showFlagAppendModal: false,
      showRecoveredModal: false,
      showAnnouncementModal: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.fetchFlaggedAssets = this.fetchFlaggedAssets.bind(this);
    this.loadDropdowns = this.loadDropdowns.bind(this);
    this.checkValues = this.checkValues.bind(this);
    this.openAnnouncement = this.openAnnouncement.bind(this);
    this.checkValue = this.checkValue.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }
    this.loadDropdowns(token);
    this.fetchFlaggedAssets(token);
  }

  fetchFlaggedAssets(token, page = 0) {
    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = {};
    if (this.state.category) {
      request.categoryName = this.state.category;
    }
    if (this.state.uniqueIdentifier) {
      request.uniqueIdentifier = this.state.uniqueIdentifier;
    }
    if (this.state.assetStatus) {
      request.assetStatus = this.state.assetStatus;
    } else {
      request.assetStatus = "FLAGGED";
    }
    if (Number(sessionStorage.getItem("lawEnforcementProfileId"))) {
      request.lawEnforcementProfileId = sessionStorage.getItem("lawEnforcementProfileId");
    }

    axios
      .post(API + "/asset/getmyflaggedlaw", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let flaggedAssets = [];
        let totalPages = 1;
        if (Array.isArray(response.data)) {
          flaggedAssets = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          flaggedAssets = response.data.content;
          totalPages = response.data.totalPages || 1;
        }
        this.setState({
          flaggedAssets,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          flaggedAssets: [],
          totalPages: 1,
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to load flagged assets.",
          toastColor: "danger",
        });
      });
  }

  loadDropdowns(token) {
    axios
      .get(API + "/asset/getmyassetflaggedsearchdropdownlist", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({
          categories: data.categories || [],
          statuses: data.assetStatuss || [],
        });
      })
      .catch((error) => {
        // Don't show error for dropdown loading failure, just continue
        console.log("Failed to load dropdowns:", error);
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  handleSearch(e) {
    e.preventDefault();
    const token = sessionStorage.getItem("token");
    this.fetchFlaggedAssets(token, 0);
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchFlaggedAssets(token, this.state.page - 1);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchFlaggedAssets(token, this.state.page + 1);
    }
  }
  checkValues() {
    let list = this.state.flaggedAssets
    for (let a in list) {
      list[a].checked = !this.state.checkedAll
    }
    this.setState({ checkedAll: !this.state.checkedAll, flaggedAssets: list })
  }
  checkValue(flagId) {
    let list = this.state.flaggedAssets
    for (let a in list) {
      if (list[a].flagId === flagId) {
        list[a].checked = !list[a].checked
      }

    }
    this.setState({ flaggedAssets: list })
  }
  openAnnouncement() {
    let list = this.state.flaggedAssets
    let checkedList = []
    for (let a in list) {
      if (list[a].checked) {
        checkedList.push(list[a].flagId)
      }
    }
    this.setState({ checkedList, showAnnouncementModal: true })
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    const rowButtons = (asset) => {
      const appendButton =
        asset?.primaryStatus?.toUpperCase() === "FLAGGED" && asset.officialReport === 'NO' ? (
          <a
            key={`flag-append-action-clickable`}
            className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover cursor-pointer"
            onClick={() =>
              this.setState({
                showFlagAppendModal: true,
                currentAssetId: asset.assetId,
                flag: asset,
              })
            }
          >
            Append
          </a>
        ) : null;

      const recoveredButton =
        asset?.primaryStatus?.toUpperCase() === "RECOVERED" ? (
          <a
            key={`recover-action-clickable`}
            className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover cursor-pointer"
            onClick={() =>
              this.setState({
                showRecoveredModal: true,
                currentAssetId: asset.assetId,
                currentAssetType: asset.categoryName,
                currentAssetModel: asset.subcategoryName,
                currentAssetBrand: asset.brand,
                currentAssetUniqueIdentier: asset.uniqueIdentifier,
              })
            }
          >
            Recovered
          </a>
        ) : null;

      return (
        <div className="d-flex gap-1 flex-wrap w-44">
          {appendButton}
          {recoveredButton}
        </div>
      );
    };

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Flagged Items" />
          {divMsg}
          <div className="w-100 flex-grow-1 px-5 d-flex flex-column align-items-center justify-content-start">
            <form
              className="row g-2 w-100 mb-2"
              autoComplete="off"
              onSubmit={this.handleSearch}
            >
              <div className="input-group col-span-4">
                <label className="input-group-text !w-fit">Category</label>
                <select
                  name="category"
                  className="form-control"
                  value={s.category}
                  onChange={this.handleChange}
                >
                  <option value="">Select</option>
                  {s.categories.map((cat, index) => (
                    <option key={`category-${index}`} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
                {s.errors.category && (
                  <span className="input-group-error">{s.errors.category}</span>
                )}
              </div>
              <div className="input-group col-span-4">
                <label className="input-group-text !w-fit">
                  Unique Identifier
                </label>
                <input
                  name="uniqueIdentifier"
                  className="form-control"
                  type="text"
                  value={s.uniqueIdentifier}
                  onChange={this.handleChange}
                />
                {s.errors.uniqueIdentifier && (
                  <span className="input-group-error">
                    {s.errors.uniqueIdentifier}
                  </span>
                )}
              </div>
              <div className="input-group col-span-3">
                <label className="input-group-text !w-fit">Status</label>
                <select
                  name="status"
                  className="form-control"
                  value={s.assetStatus}
                  onChange={(e) =>
                    this.handleSelect("assetStatus", e ? e.target.value : "")
                  }
                >
                  <option value="">Select</option>
                  {s.statuses.map((stat, index) => (
                    <option key={`asset-status-${index}`} value={stat}>
                      {stat}
                    </option>
                  ))}
                </select>
                {s.errors.status && (
                  <span className="input-group-error">{s.errors.status}</span>
                )}
              </div>
              <button
                type="button"
                className="btn btn-primary col-span-1"
                onClick={this.handleSearch}
              >
                Search
              </button>
            </form>
            {(s.assetStatus === 'LOST' || s.assetStatus === 'STOLEN') && <div className="d-flex gap-4 mt-2 mb-2 w-100 justify-content-start">
              <button
                className="btn btn-primary"
                onClick={this.openAnnouncement}
              >Add To Annoucement</button>
            </div>}
            <div className="w-100 overflow-auto border rounded">
              <table className="table table-striped table-hover rounded">
                <thead className="table-primary">
                  <tr>
                    {(s.assetStatus === 'LOST' || s.assetStatus === 'STOLEN') && <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      <input
                        name="checkBoxAll"
                        type="checkbox"
                        onChange={this.checkValues}
                      />
                    </th>}
                    <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      Category
                    </th>
                    <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      Unique Identifier
                    </th>
                    <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="">
                  {s.flaggedAssets.map((asset, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      {(s.assetStatus === 'LOST' || s.assetStatus === 'STOLEN') && <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                        <input
                          name="checkBox"
                          type="checkbox"
                          checked={asset.checked}
                          onChange={() => this.checkValue(asset.flagId)}
                        />
                      </td>}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                        {asset.categoryName || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                        {asset.subcategoryName || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                        {asset.uniqueIdentifier || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                        {asset.primaryStatus || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm fw-medium">
                        {rowButtons(asset)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {s.flaggedAssets.length === 0 && (
                <div className="text-muted text-center py-4">
                  No flagged assets found.
                </div>
              )}
            </div>

            {s.totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                <button
                  className="btn btn-outline"
                  disabled={s.page === 0}
                  onClick={this.handlePreviousPage}
                >
                  Previous
                </button>
                <span>
                  Page {s.page + 1} of {s.totalPages}
                </span>
                <button
                  className="btn btn-outline"
                  disabled={s.page + 1 >= s.totalPages}
                  onClick={this.handleNextPage}
                >
                  Next
                </button>
              </div>
            )}
          </div>

        </div>
        {s.showRecoveredModal && (
          <Recovered
            key={`recover-asset-${s.currentAssetId}`}
            closeAction={() => this.setState({ showRecoveredModal: false })}
            assetId={s.currentAssetId}
            assetType={s.currentAssetType}
            assetBrand={s.currentAssetBrand}
            assetModel={s.currentAssetModel}
            assetUniqueIdentier={s.currentAssetUniqueIdentier}
            onSuccess={() => {
              this.setState({ showRecoveredModal: false });
              this.fetchFlaggedAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
        {s.showFlagAppendModal && (
          <FlagAppend
            key={`asset-flag-append-${s.currentAssetId}`}
            closeAction={() => this.setState({ showFlagAppendModal: false })}
            assetId={s.currentAssetId}
            flag={s.flag}
            onSuccess={() => {
              this.setState({ showFlagAppendModal: false });
              this.fetchFlaggedAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
        {s.showAnnouncementModal && (
          <AnnouncementBulk
            key={`asset-flag-announcement-${s.currentAssetId}`}
            closeAction={() => this.setState({ showAnnouncementModal: false })}
            checkedList={s.checkedList}
            onSuccess={() => {
              this.setState({ showAnnouncementModal: false });
              this.fetchFlaggedAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
      </div>
    );
  }
}
